import React, { useState, useEffect } from "react";
import Select from "react-select";
import { Modal } from "react-bootstrap";

import { URLS } from "../urls";

import Datepicker from "react-datetime";
import moment from "moment";
import "../../../src/assets/css/ga-styles.css";
import { toast } from "react-toastify";
import { branch_id } from "../../utils";

export function AddTerminationModal(props) {
  const date = new Date();
  const initialTerminationData = {
    employeeId: "",
    departmentId: "",
    reason: "",
    noticeDate: moment(date).format("DD/MM/YYYY"),
    terminationDate: moment(date).format("DD/MM/YYYY"),
    terminationType: ["misconduct"],
    branch_id,
  };

  const [employees, setEmployees] = useState([]);
  const [terminationData, setTerminationData] = useState(
    initialTerminationData
  );
  const [mapEmployees, setMapEmployees] = useState([]);

  const [terminations, setTerminations] = useState([]);

  useEffect(() => {
    getEmployees();
    // getTerminations();
    return () => {};
  }, []);

  const setEmployeeId = (userId) => {
    const employee = employees.find((employee) => employee.userId === userId);
    setTerminationData({
      ...terminationData,
      employeeId: userId,
      departmentId: employee?.jobInfo?.department?._id,
    });
  };

  useEffect(() => {
    if (props.userId) {
      setEmployeeId(props.userId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.userId]);

  const getEmployees = async () => {
    const token = "dummy token";

    const resTer = await fetch(
      `${URLS.backendTermination}/get-terminations/${branch_id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Token ${token}`,
        },
      }
    );

    const res = await fetch(`${URLS.backendEmployees}/get/${branch_id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const { employees } = await res.json();

    const { terminations } = await resTer.json();

    setTerminations(terminations);
    setEmployees(employees);
    if (employees) {
      const em = employees
        .filter((el) =>
          terminations.every((ems) => ems?.employeeId !== el?.userId)
        )
        .map((d) => ({
          label: `${
            d?.personalInfo?.name?.first ? d?.personalInfo?.name?.first : ""
          } ${
            d?.personalInfo?.name?.middle ? d?.personalInfo?.name?.middle : ""
          } ${d?.personalInfo?.name?.last ? d?.personalInfo?.name?.last : ""}`,
          value: d.userId,
        }));
      setMapEmployees(em);
    }
  };

  const saveTermination = (e) => {
    e.preventDefault();

    const token = "dummy token";
    fetch(`${URLS.backendTermination}/save`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
      body: JSON.stringify({ terminationData }),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.success) {
          // console.log(result);
          setTerminations([...terminations, result.termination]);
          setTerminationData({ ...initialTerminationData });
          props.setReload && props.setReload();
          props.handleClose && props.handleClose();
          toast("Employee terminated", {
            type: "success",
          });
        } else {
          if (result.exists) {
            toast("Employee has already been terminated", {
              type: "error",
            });
            return;
          }
          throw Error();
        }
      })
      .catch((err) => {
        console.log(err);
        toast("Unable to submit", {
          type: "error",
        });
      });
  };

  return (
    <Modal
      {...props}
      show={props.show}
      onHide={props.handleClose}
      aria-labelledby=""
      centered
      size="md"
    >
      <Modal.Header closeButton>
        <Modal.Title>Add Termination</Modal.Title>
      </Modal.Header>
      <div>
        <div className="">
          <div className="">
            <div className="modal-body">
              <form onSubmit={(e) => saveTermination(e)}>
                <div className="form-group">
                  <label>
                    Terminated Employee <span className="text-danger">*</span>
                  </label>
                  {props.name ? (
                    <input
                      className="form-control"
                      value={props.name}
                      readOnly
                    />
                  ) : (
                    <>
                      {employees && (
                        <Select
                          closeMenuOnSelect={true}
                          isSearchable={true}
                          value={mapEmployees.filter(
                            (el) => el.value === terminationData.employeeId
                          )}
                          onChange={(selected) => {
                            setEmployeeId(selected?.value);
                          }}
                          options={mapEmployees}
                        />
                      )}
                    </>
                  )}
                </div>
                <div className="form-group">
                  <label>
                    Termination Type <span className="text-danger">*</span>
                  </label>
                  <div className="">
                    {terminationData.terminationType.map((type, index) => {
                      return (
                        <div key={index} className="d-flex">
                          <select
                            value={type}
                            className="form-control"
                            onChange={(e) => {
                              const terminationType =
                                terminationData.terminationType;
                              terminationType[index] = e.target.value;
                              setTerminationData({
                                ...terminationData,
                                terminationType,
                              });
                            }}
                          >
                            <option value="">Select Termination type</option>
                            <option value="misconduct">Misconduct</option>
                            <option value="abuse">Abuse</option>
                            <option value="others">Others</option>
                          </select>
                          <span
                            className="m-3"
                            title="remove"
                            onClick={() => {
                              if (terminationData.terminationType.length > 1) {
                                const terminationType =
                                  terminationData.terminationType;
                                terminationType.splice(index, 1);
                                setTerminationData({
                                  ...terminationData,
                                  terminationType,
                                });
                              }
                            }}
                          >
                            <i className="fa fa-times"></i>
                          </span>
                        </div>
                      );
                    })}

                    <div
                      className="btn btn-primary p-cursor"
                      onClick={() =>
                        setTerminationData({
                          ...terminationData,
                          terminationType: [
                            ...terminationData.terminationType,
                            "",
                          ],
                        })
                      }
                    >
                      <i className="fa fa-plus"></i> Add
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label>
                    Termination Date <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    <div classname="datePicker position-absolute">
                      <Datepicker
                        id={"terminationDate"}
                        value={terminationData.terminationDate}
                        onChange={(e) => {
                          setTerminationData({
                            ...terminationData,
                            terminationDate: moment(e._d).format("DD/MM/YYYY"),
                          });
                        }}
                        closeOnSelect={true}
                      />
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <label>
                    Reason <span className="text-danger">*</span>
                  </label>
                  <textarea
                    className="form-control"
                    rows="4"
                    value={terminationData.reason}
                    onChange={(e) => {
                      setTerminationData({
                        ...terminationData,
                        reason: e.target.value,
                      });
                    }}
                  ></textarea>
                </div>
                <div className="form-group">
                  <label>
                    Notice Date <span className="text-danger">*</span>
                  </label>
                  <div className="cal-icon">
                    <Datepicker
                      id={"noticeDate"}
                      value={terminationData.noticeDate}
                      onChange={(e) => {
                        setTerminationData({
                          ...terminationData,
                          noticeDate: moment(e._d).format("DD/MM/YYYY"),
                        });
                      }}
                      closeOnSelect={true}
                    />
                  </div>
                </div>
                <div className="submit-section">
                  <button className="btn btn-primary submit-btn">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
}
